import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import ColorBucket from "./ColorBucket";
import { RGBToHex, changeBucketColorAccordingBackground, hexToRGB } from "../../../_helpers/utils";
import { EditorContext } from "../../../containers/editor/EditorLayout";

let style = Object.assign({}, global);

const TColor = () => {
  let { metadata, widgets, updateWidgets } = useContext(EditorContext);

  let activeElement = document.getElementById(metadata.activeWidgetId[0]);
  let targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);

  const [sectionHeaderColor, setSectionHeaderColor] = useState();
  const [headerBucketColor, setHeaderBucketColor] = useState();
  const [headerEyeDroppercolor, setHeaderEyeDroppercolor] = useState();
  const [sectionSubheaderColor, setSectionSubheaderColor] = useState();
  const [subheaderBucketColor, setSubheaderBucketColor] = useState();
  const [subheaderEyeDroppercolor, setSubheaderEyeDroppercolor] = useState();
  const [sectionBodyColor, setSectionBodyColor] = useState();
  const [bodyBucketColor, setBodyBucketColor] = useState();
  const [bodyEyeDroppercolor, setBodyEyeDroppercolor] = useState();
  const [sectionBorderColor, setSectionBorderColor] = useState();
  const [borderBucketColor, setBorderBucketColor] = useState();
  const [borderEyeDropperColor, setBorderEyeDropperColor] = useState();
  const [grandTotalBodyColor, setGrandTotalBodyColor] = useState();
  const [totalBodyBucketColor, setTotalBodyBucketColor] = useState();
  const [totalBodyEyeDroppercolor, setTotalBodyEyeDroppercolor] = useState();
  const [grandTotalBorderColor, setGrandTotalBorderColor] = useState();
  const [totoalBorderBucketColor, setTotoalBorderBucketColor] = useState();
  const [totalBorderEyeDroppercolor, setTotalBorderEyeDroppercolor] = useState();
  const [loadCureentFormatting, setLoadCureentFormatting] = useState();
  const [updateContext, setUpdateContext] = useState(false);

  // change header color
  useEffect(() => {
    if (sectionHeaderColor && !loadCureentFormatting) {
      let backgroundColorRange = changeBucketColorAccordingBackground(hexToRGB(sectionHeaderColor));

      activeElement.querySelectorAll(".pricing-table-section .card-header").forEach(element => {
        element.style.backgroundColor = sectionHeaderColor; // set header color

        // set header content color based on background color range
        element.querySelectorAll("*").forEach(child => {
          child.style.color = backgroundColorRange === "dark" ? "#ffffff" : "#000000";
        });
      });

      sectionHeaderColor && setHeaderBucketColor(backgroundColorRange);
    }
  }, [sectionHeaderColor]);

  //update section header color from eyedropper
  useEffect(() => {
    if (headerEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setSectionHeaderColor(headerEyeDroppercolor);
      setHeaderEyeDroppercolor();
    }
  }, [headerEyeDroppercolor]);

  // change subheader color
  useEffect(() => {
    if (sectionSubheaderColor && !loadCureentFormatting) {
      let backgroundColorRange = changeBucketColorAccordingBackground(hexToRGB(sectionSubheaderColor));

      activeElement.querySelectorAll(".item-label").forEach(element => {
        element.style.backgroundColor = sectionSubheaderColor; // set sub-header color

        // set sub-header content color based on background color range
        element.querySelector("ul").childNodes.forEach(child => {
          child.style.color = backgroundColorRange === "dark" ? "#ffffff" : "#000000";
        });
      });

      sectionSubheaderColor && setSubheaderBucketColor(backgroundColorRange);
    }
  }, [sectionSubheaderColor]);

  //update section sub header color from eyedropper
  useEffect(() => {
    if (subheaderEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setSectionSubheaderColor(subheaderEyeDroppercolor);
      setSubheaderEyeDroppercolor();
    }
  }, [subheaderEyeDroppercolor]);

  // change body color
  useEffect(() => {
    if (sectionBodyColor && !loadCureentFormatting) {
      let backgroundColorRange = changeBucketColorAccordingBackground(hexToRGB(sectionBodyColor));

      activeElement.querySelectorAll(".item-details").forEach(element => {
        element.style.backgroundColor = sectionBodyColor; // set section body color
        element.style.color = backgroundColorRange === "dark" ? "#ffffff" : "#000000"; // set section body content color based on background color range
      });

      sectionBodyColor && setBodyBucketColor(backgroundColorRange);
    }
  }, [sectionBodyColor]);

  //update section body color from eyedropper
  useEffect(() => {
    if (bodyEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setSectionBodyColor(bodyEyeDroppercolor);
      setBodyEyeDroppercolor();
    }
  }, [bodyEyeDroppercolor]);

  // change section border color
  useEffect(() => {
    if (sectionBorderColor && !loadCureentFormatting) {
      activeElement.querySelectorAll(".pricing-table-section").forEach(element => {
        element.style.border = `1px solid ${sectionBorderColor}`;
      });
      activeElement.querySelectorAll(".pricing-table-section .card-header").forEach(element => {
        element.style.borderBottom = `1px solid ${sectionBorderColor}`;
      });
      activeElement.querySelectorAll(".pricing-table-section .card-body .item-label").forEach(element => {
        element.style.borderBottom = `1px solid ${sectionBorderColor}`;
      });
      activeElement.querySelectorAll(".pricing-table-section .card-body .item-details").forEach(element => {
        element.style.borderBottom = `1px solid ${sectionBorderColor}`;
      });

      sectionBorderColor && setBorderBucketColor(changeBucketColorAccordingBackground(hexToRGB(sectionBorderColor)));
    }
  }, [sectionBorderColor]);

  //update section border color from eyedropper
  useEffect(() => {
    if (borderEyeDropperColor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setSectionBorderColor(borderEyeDropperColor);
      setBorderEyeDropperColor();
    }
  }, [borderEyeDropperColor]);

  // change summury body color
  useEffect(() => {
    if (grandTotalBodyColor && !loadCureentFormatting) {
      let backgroundColorRange = changeBucketColorAccordingBackground(hexToRGB(grandTotalBodyColor));

      activeElement.querySelectorAll(".pricing-table-total").forEach(element => {
        element.style.backgroundColor = grandTotalBodyColor; // set grand total body color

        // set grand total body content color based on background color range
        element.querySelectorAll("h6").forEach(el => {
          el.style.color = backgroundColorRange === "dark" ? "#ffffff" : "#000000";
        });
      });

      grandTotalBodyColor && setTotalBodyBucketColor(backgroundColorRange);
    }
  }, [grandTotalBodyColor]);

  //update summury body color from eyedropper
  useEffect(() => {
    if (totalBodyEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setGrandTotalBodyColor(totalBodyEyeDroppercolor);
      setTotalBodyEyeDroppercolor();
    }
  }, [totalBodyEyeDroppercolor]);

  // change summury border color
  useEffect(() => {
    if (grandTotalBorderColor && !loadCureentFormatting) {
      activeElement.querySelectorAll(".pricing-table-total").forEach(element => {
        element.style.border = `1px solid ${grandTotalBorderColor}`;
      });
      activeElement.querySelectorAll(".pricing-table-total .card-header").forEach(element => {
        // element.style.borderBottom = `1px solid ${grandTotalBorderColor}`;
      });
    }

    grandTotalBorderColor &&
      setTotoalBorderBucketColor(changeBucketColorAccordingBackground(hexToRGB(grandTotalBorderColor)));
  }, [grandTotalBorderColor]);

  //update summury border color from eyedropper
  useEffect(() => {
    if (totalBorderEyeDroppercolor) {
      setUpdateContext(true);
      setLoadCureentFormatting(false);
      setGrandTotalBorderColor(totalBorderEyeDroppercolor);
      setTotalBorderEyeDroppercolor();
    }
  }, [totalBorderEyeDroppercolor]);

  // load current formatting
  useEffect(() => {
    setLoadCureentFormatting(true);

    if (activeElement) {
      let headerColor = activeElement.querySelector(".pricing-table-section .card-header").style.backgroundColor
        ? RGBToHex(activeElement.querySelector(".pricing-table-section .card-header").style.backgroundColor)
        : "#4472c4";
      setSectionHeaderColor(headerColor);
      setHeaderBucketColor(changeBucketColorAccordingBackground(hexToRGB(headerColor)));

      let subHeaderColor = activeElement.querySelector(".item-label").style.backgroundColor
        ? RGBToHex(activeElement.querySelector(".item-label").style.backgroundColor)
        : "#dae3f3";
      setSectionSubheaderColor(subHeaderColor);
      setSubheaderBucketColor(changeBucketColorAccordingBackground(hexToRGB(subHeaderColor)));

      let bodyColor = activeElement.querySelector(".item-details").style.backgroundColor
        ? RGBToHex(activeElement.querySelector(".item-details").style.backgroundColor)
        : "#ffffff";
      setSectionBodyColor(bodyColor);
      setBodyBucketColor(changeBucketColorAccordingBackground(hexToRGB(bodyColor)));

      let sectionBorder = activeElement.querySelector(".pricing-table-section .card-body .item-label").style
        .borderBottom;
      sectionBorder = sectionBorder ? RGBToHex(`rgb${sectionBorder.split("rgb")[1]}`) : "#4472c4";
      setSectionBorderColor(sectionBorder);
      setBorderBucketColor(changeBucketColorAccordingBackground(hexToRGB(sectionBorder)));

      if (document.querySelector(`#${metadata.activeWidgetId[0]} .pricing-table-total`)) {
        let grandBodyColor = activeElement.querySelector(".pricing-table-total").style.backgroundColor
          ? RGBToHex(activeElement.querySelector(".pricing-table-total").style.backgroundColor)
          : "#4472c4";
        setGrandTotalBodyColor(grandBodyColor);
        setTotalBodyBucketColor(changeBucketColorAccordingBackground(hexToRGB(grandBodyColor)));

        let grandTotalBorder = activeElement
          .querySelector(".pricing-table-total")
          .style.border?.split("solid")[1]
          ?.trimStart();
        grandTotalBorder = grandTotalBorder ? RGBToHex(`rgb${grandTotalBorder.split("rgb")[1]}`) : "#dae3f3";
        setGrandTotalBorderColor(grandTotalBorder);
        setTotoalBorderBucketColor(changeBucketColorAccordingBackground(hexToRGB(grandTotalBorder)));
      }
    }
  }, [activeElement]);

  // update context
  useEffect(() => {
    let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
    tableConfig = JSON.parse(tableConfig);

    let colorConfig = {
      sectionHeaderColor: sectionHeaderColor,
      sectionHeaderContentColor:
        changeBucketColorAccordingBackground(hexToRGB(sectionHeaderColor)) === "dark" ? "#ffffff" : "#000000",
      sectionSubheaderColor: sectionSubheaderColor,
      sectionSubheaderContentColor:
        changeBucketColorAccordingBackground(hexToRGB(sectionSubheaderColor)) === "dark" ? "#ffffff" : "#000000",
      sectionBodyColor: sectionBodyColor,
      sectionBodyContentColor:
        changeBucketColorAccordingBackground(hexToRGB(sectionBodyColor)) === "dark" ? "#ffffff" : "#000000",
      sectionBorderColor: sectionBorderColor,
    };

    if (document.querySelector(`#${metadata.activeWidgetId[0]} .pricing-table-total`)) {
      colorConfig = {
        ...colorConfig,
        grandTotalBodyColor: grandTotalBodyColor,
        grandTotalBodyContentColor:
          changeBucketColorAccordingBackground(hexToRGB(grandTotalBodyColor)) === "dark" ? "#ffffff" : "#000000",
        grandTotalBorderColor: grandTotalBorderColor,
      };
    }

    let newTableConfig = { ...tableConfig, ...colorConfig };
    const jsonString = JSON.stringify(newTableConfig);
    const widgetObject = widgets[targetWidgetIndex];
    let newArray = Object.assign([...widgets], {
      [targetWidgetIndex]: {
        ...widgetObject,
        data: {
          ...widgetObject.data,
          "data-table-config": jsonString,
        },
        innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
      },
    });
    updateContext && updateWidgets(newArray);
  }, [
    updateContext,
    sectionHeaderColor,
    sectionSubheaderColor,
    sectionBodyColor,
    sectionBorderColor,
    grandTotalBodyColor,
    grandTotalBorderColor,
  ]);

  return (
    <>
      <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
        <div className={style["slidelabel"]}>Section Header</div>
        <ColorBucket
          color={sectionHeaderColor}
          setColor={setSectionHeaderColor}
          iconBucketColor={headerBucketColor}
          position={"toolbar"}
          eyedropperColor={headerEyeDroppercolor}
          setEyedropperColor={setHeaderEyeDroppercolor}
          setLoadCurrentFormatting={setLoadCureentFormatting}
          isHideTransparentOpt={true}
          setUpdateContext={setUpdateContext}
        />
      </div>

      <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
        <div className={style["slidelabel"]}>Section Subheader</div>
        <ColorBucket
          color={sectionSubheaderColor}
          setColor={setSectionSubheaderColor}
          iconBucketColor={subheaderBucketColor}
          position={"toolbar"}
          eyedropperColor={subheaderEyeDroppercolor}
          setEyedropperColor={setSubheaderEyeDroppercolor}
          setLoadCurrentFormatting={setLoadCureentFormatting}
          isHideTransparentOpt={true}
          setUpdateContext={setUpdateContext}
        />
      </div>

      <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
        <div className={style["slidelabel"]}>Section Body</div>
        <ColorBucket
          color={sectionBodyColor}
          setColor={setSectionBodyColor}
          iconBucketColor={bodyBucketColor}
          position={"toolbar"}
          eyedropperColor={bodyEyeDroppercolor}
          setEyedropperColor={setBodyEyeDroppercolor}
          setLoadCurrentFormatting={setLoadCureentFormatting}
          isHideTransparentOpt={true}
          setUpdateContext={setUpdateContext}
        />
      </div>

      <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
        <div className={style["slidelabel"]}>Section Border</div>
        <ColorBucket
          color={sectionBorderColor}
          setColor={setSectionBorderColor}
          iconBucketColor={borderBucketColor}
          position={"toolbar"}
          eyedropperColor={borderEyeDropperColor}
          setEyedropperColor={setBorderEyeDropperColor}
          setLoadCurrentFormatting={setLoadCureentFormatting}
          isHideTransparentOpt={true}
          setUpdateContext={setUpdateContext}
        />
      </div>

      {document.querySelector(`#${metadata.activeWidgetId[0]} .pricing-table-total`) && (
        <>
          <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
            <div className={style["slidelabel"]}>Summary Body</div>
            <ColorBucket
              color={grandTotalBodyColor}
              setColor={setGrandTotalBodyColor}
              iconBucketColor={totalBodyBucketColor}
              position={"toolbar"}
              eyedropperColor={totalBodyEyeDroppercolor}
              setEyedropperColor={setTotalBodyEyeDroppercolor}
              setLoadCurrentFormatting={setLoadCureentFormatting}
              isHideTransparentOpt={true}
              setUpdateContext={setUpdateContext}
            />
          </div>

          <div className={cx(style["line-controls-wrap"], style["justify-content-start"])}>
            <div className={style["slidelabel"]}>Summary Border</div>
            <ColorBucket
              color={grandTotalBorderColor}
              setColor={setGrandTotalBorderColor}
              iconBucketColor={totoalBorderBucketColor}
              position={"toolbar"}
              eyedropperColor={totalBorderEyeDroppercolor}
              setEyedropperColor={setTotalBorderEyeDroppercolor}
              setLoadCurrentFormatting={setLoadCureentFormatting}
              isHideTransparentOpt={true}
              setUpdateContext={setUpdateContext}
            />
          </div>
        </>
      )}
    </>
  );
};

export default TColor;
